import {
  Sun,
  Heart,
  Home,
  AlertCircle,
  Calendar,
  CheckCircle,
  Clock,
  XCircle,
} from "lucide-react";

export const calculateDuration = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffTime = Math.abs(end - start);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
};

export const getStatusColor = (status, theme) => {
  switch (status) {
    case "approved":
      return theme === "dark" ? "#10b981" : "#059669";
    case "pending":
      return theme === "dark" ? "#f59e0b" : "#d97706";
    case "rejected":
      return theme === "dark" ? "#ef4444" : "#dc2626";
    default:
      return theme === "dark" ? "#2e7cba" : "#2e7cba";
  }
};

export const getStatusIcon = (status) => {
  switch (status) {
    case "approved":
      return CheckCircle;
    case "pending":
      return Clock;
    case "rejected":
      return XCircle;
    default:
      return AlertCircle;
  }
};

export const getLeaveTypeIcon = (type) => {
  switch (type) {
    case "annual":
      return Sun;
    case "sick":
      return Heart;
    case "maternity":
      return Home;
    case "emergency":
      return AlertCircle;
    case "wfh":
      return Home;
    default:
      return Calendar;
  }
};

export const getCurrentViewType = () => {
  const storedManagerViewType = localStorage.getItem("managerViewType");
  const storedViewType = localStorage.getItem("viewType");
  return String(storedManagerViewType || storedViewType || "admin").toLowerCase();
};

export const getLeaveActionPermissions = (leaveRecord, userRole, profile) => {
  const currentViewType = getCurrentViewType();
  const isManagerInManagerView = userRole === "manager" && currentViewType === "manager";
  const isPrivilegedRole = userRole === "admin" || userRole === "superadmin";

  let leaveFeatures = [];
  try {
    const adminLevel = profile?.adminLevel || null;
    leaveFeatures = adminLevel?.features?.leaves || [];
  } catch (parseError) {
    leaveFeatures = [];
  }

  // Visibility and authority are separate. A manager sees every request from
  // their first- and second-line reports, but the workflow decides who may
  // act. `canAct` is computed server-side and is true only when the workflow
  // instance is currently waiting on this user's step — so a manager who
  // isn't in the workflow at all, or who is a later-stage approver whose turn
  // hasn't come, gets a read-only view. Requests with no workflow attached
  // are never actionable from this page.
  const isManager = userRole === "manager";
  const isWorkflowTurn = leaveRecord?.canAct === true;
  const blockedByWorkflow = isManager && !isWorkflowTurn;

  const hasApprovePermission =
    !blockedByWorkflow &&
    (isPrivilegedRole || isManagerInManagerView || leaveFeatures.includes("approve"));
  const hasRejectPermission =
    !blockedByWorkflow &&
    (isPrivilegedRole || isManagerInManagerView || leaveFeatures.includes("reject"));

  return {
    hasApprovePermission,
    hasRejectPermission,
    hasAnyPermission: hasApprovePermission || hasRejectPermission,
    currentViewType,
    isManagerInManagerView,
    isWorkflowTurn,
    blockedByWorkflow,
    leaveRecord,
  };
};